import { HttpClient, HttpParams } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router'
import { NgbModal } from '@ng-bootstrap/ng-bootstrap'
import { Observable, of } from 'rxjs'
import { catchError, map } from 'rxjs/operators'
import { getSessionFromLocalStorage } from 'src/app/utils/getSessionFromLocalStorage'
import { environment } from 'src/environments/environment'
import { UserModel } from '../_models/user.model'
import { AuthService } from './auth.service'
const Abonnement_Routes = {
  community_actif: ['/community', '/community/gestion', '/community/mycommunities', ,],
  entreprise_annuaire_actif: ['/collaborateurs/mes-collegue'],
  evenement_actif: ['/events', '/events/gerer', '/evenement/actif'],
  onboarding_actif: ['/strategie/onboarding'],
  idea_actif: ['/ideas', '/ideas/ideas', '/ideas/adminIdeas'],
  question_reponse_actif: ['/questions', '/questions/question-recue', '/questions/mes-questions'],
  formation_actif: [
    '/formations',
    '/formations/mes-formations',
    '/formations/cibles',
    '/formations/formations-collaborateurs',
  ],
  bsi_actif: ['/bsi', '/mes-bsi'],
}
@Injectable({ providedIn: 'root' })
export class AuthGuard {
  protected authLocalStorageToken = `${environment.appVersion}-${environment.USERDATA_KEY}`
  constructor(
    private router: Router,
    private authService: AuthService,
    private http: HttpClient,
    private modalService: NgbModal
  ) {}
  toggleScreenIsBusyFalse(busy: boolean) {
    const HTML = document.getElementsByTagName('html')[0]

    HTML.style.pointerEvents = busy ? 'wait' : 'auto'
    //HTML.style.cursor = busy ? 'wait' : 'auto'

    const modal = document.getElementsByClassName('modal-content')[0] as HTMLDivElement

    modal.style.pointerEvents = busy ? 'wait' : 'auto'
    //modal.style.cursor = busy ? 'wait' : 'unset'
  }
  textError: String = null

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    // localStorage.setItem('returnUrl', JSON.stringify('/'))
    const currentUser = this.authService.currentUserValue
    const isCourrierRoute: boolean = /^\/(mes-courriers|campaign-courrier)(?:[/?;#]|$)/.test(state.url)

    if (currentUser) {
      var d = new Date()

      //current user n exist pas
      var expire_date = new Date(currentUser[0].expire_date)

      // let expire_date_abonnement = new Date(currentUser[0].date_fin_abonnement)
      // let begin_date_abonnement = new Date(currentUser[0].date_debut_abonnement)
      // // Check if the subscription has not started or has expired
      // if (currentUser[0]?.ent_id && (begin_date_abonnement > d || expire_date_abonnement < d)) {
      //   this.router.navigate(['/auth/login'], {
      //     queryParams: {},
      //   })
      //   return false
      // }
    }
    if (currentUser && currentUser[0].session_status != 0 && expire_date > d) {
      // check if route is restricted by role
      if (route.data.IdRole_Role && route.data.IdRole_Role.indexOf(currentUser[0].IdRole_Role) === -1) {
        // role not authorised so redirect to home page

        this.router.navigate(['/auth/login'], {
          queryParams: {},
        })

        return false
      }

      if (this.router.url.indexOf('external=true') > -1) {
        // get full url with query params
        const url = new URL(window.location.href)
        const source = url.searchParams.get('source')
        const userId = url.searchParams.get('userId')
        const userEmail = url.searchParams.get('userEmail')
        const token = url.searchParams.get('token')

        this.http
          .post<any>(
            `${environment.apiUrl}/auth/ext-chatbot/register`,
            {
              source,
              userId,
              userEmail,
              token,
            },
            { params: new HttpParams().set('sessionid', getSessionFromLocalStorage()) }
          )
          .subscribe({
            next: _ => {
              return this.router.navigate(['/ext-auth-success'])
            },
            error: error => {
              console.log(error)
              return this.router.navigate(['/ext-auth-success'])
            },
          })
      }

      if (this.router.url.indexOf('chrome_extension=linkedin') > -1) {
        // navigate to the external auth success page and add query param sessionId = getSessionFromLocalStorage()
        this.router.navigate(['/ext-auth-success'], {
          queryParams: { sessionId: getSessionFromLocalStorage() },
        })
        return
      }

      //Vérification des permissions
      //Vérification des permissions
      if (route.data?.CD_Permission) {
        //current user est tableau des objest:exmple [{nom:khaled,CD_Permission:'rrr},{nom:ali,CD_Permission:'xxr'}]
        //extract CD_Permission of this user
        const userPermissions = currentUser[0].CD_Permission || [] // Assurez-vous que CD_Permission est bien un tableau dans votre modèle utilisateur

        const hasPermission = route.data.CD_Permission.some(permission => userPermissions.includes(permission))
        if ((hasPermission || currentUser[0].IdRole_Role == 0) && !isCourrierRoute) {
          return true
        }
        if (!hasPermission && currentUser[0].IdRole_Role != 0) {
          this.router.navigate(['/dashboard'], { queryParams: {} })
          return false
        }
      }

      if (isCourrierRoute) {
        return this.authService.getUserByToken2(getSessionFromLocalStorage()).pipe(
          map((users: any): boolean => {
            const enabled: boolean = users?.[0]?.courrier_actif === 1 && users?.[0]?.paies_actif === 1
            if (!enabled) {
              this.router.navigate(['/dashboard'])
            }
            return enabled
          }),
          catchError((): Observable<boolean> => {
            this.router.navigate(['/dashboard'])
            return of(false)
          })
        )
      }

      this.verifAbonnement(currentUser)

      return true
    }

    if (this.router.url.indexOf('external=true') === -1 && this.router.url.indexOf('chrome_extension=linkedin') === -1)
      this.router.navigate(['/auth/login'], {
        queryParams: { returnUrl: state.url },
      })
    // not logged in so redirect to login page with the return url

    return false
  }
  verifAbonnement(currentUser: UserModel) {
    //get current path of browser
    let current_url = window.location.pathname
    const {
      community_actif,
      entreprise_annuaire_actif,
      evenement_actif,
      idea_actif,
      onboarding_actif,
      question_reponse_actif,
      formation_actif,
      bsi_actif,
    } = currentUser[0]

    const abonnement = {
      community_actif,
      entreprise_annuaire_actif,
      evenement_actif,
      idea_actif,
      onboarding_actif,
      question_reponse_actif,
      formation_actif,
      bsi_actif,
    }
    for (const [key, value] of Object.entries(abonnement)) {
      if (value != 1 && Abonnement_Routes[key].includes(current_url)) {
        this.router.navigate(['/error/404'])
      }
    }

    //le cas ou onboarding est desactivé en abonnement
  }
}
